<section class="comp-org-account-setting">
  <div class="p-grid" style="margin-top:15px;"></div>

  <app-data-table [columns]="tableColumns" [value]="accountSettings" sortField="accountSettingsType" [sortOrder]="PrimeNgConfig.TableAscSortOrder">
    <ng-template #actionTemplate let-row="row">
      <button *ngIf="row?.refId" pButton type="button" class="icon-action" icon="fa fa-pencil"
              (click)="onClickEditAccount(row)"></button>
      <button *ngIf="!row?.refId" pButton type="button" class="icon-action" icon="fa fa-clone"
              pTooltip="Override" tooltipPosition="top"
              (click)="onClickEditAccount(row)"></button>
    </ng-template>
  </app-data-table>

  <p-dialog *ngIf="selectedAccountSetting&&displayAccountDialog" [(visible)]="displayAccountDialog"
            header="Edit Setting" [dismissableMask]="true" [responsive]="true" [modal]="true" [style]="PrimeNgConfig.DialogStyle40">
    <form #dialogForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Account</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="account" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                      [options]="ledgerAccountsDropdown" [filter]="true"
                      [(ngModel)]="selectedAccountSetting.ledgerAccountInfo"
                      (onChange)="onChangeSelectedAccount($event)" required></p-dropdown>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Account Number</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedAccountSetting.ledgerAccountInfo.accountNumber}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Description</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedAccountSetting.ledgerAccountInfo.accountDescription}}</div>
      </div>
      <p-footer>
        <div style="text-align:right;">
          <button pButton class="button-inaction" label="Cancel"
                  (click)="onCloseDialog()"></button>
          <button pButton class="button-action" label="Save"
                  (click)="onClickUpdateAccount(selectedAccountSetting)"
                  [disabled]="!selectedAccountSetting.ledgerAccountId || !dialogForm.valid"></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

  <p-confirmDialog></p-confirmDialog>

  <div style="clear:both;"></div>
</section>
